import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsTextEllipsisPrepend]'
})
export class TextEllipsisPrependDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input() hide = false;
}
